import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const POST_TERMS_PRIVACY_DATA = 'POST_TERMS_PRIVACY_DATA';
export const POST_TERMS_PRIVACY_DATA_SUCCESS =
  'POST_TERMS_PRIVACY_DATA_SUCCESS';
export const POST_TERMS_PRIVACY_DATA_FAILURE =
  'POST_TERMS_PRIVACY_DATA_FAILURE';

// Action Creators
export const postTermsPrivacy = () => ({
  type: POST_TERMS_PRIVACY_DATA,
});

export const postTermsPrivacySuccess = (users) => ({
  type: POST_TERMS_PRIVACY_DATA_SUCCESS,
  payload: users,
});

export const postTermsPrivacyFailure = (error) => ({
  type: POST_TERMS_PRIVACY_DATA_FAILURE,
  payload: error,
});

// Thunk Function
export const postTermsPrivacyDataCallApi = (external, body) => {
  return async (dispatch) => {
    dispatch(postTermsPrivacy());
    try {
      const response = await postMethodWithToken(
        url.postTermsConditionPrivacyPolicy,
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(postTermsPrivacySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(postTermsPrivacyFailure(error?.message));
    }
  };
};
